/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversation } from '../../models/api-response-conversation';
import { CreateConversation } from '../../models/create-conversation';

export interface StartNewConversationWithMedia$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'createConversation': CreateConversation;
'mediaList': Array<Blob>;
}
}

export function startNewConversationWithMedia(http: HttpClient, rootUrl: string, params: StartNewConversationWithMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
  const rb = new RequestBuilder(rootUrl, startNewConversationWithMedia.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversation>;
    })
  );
}

startNewConversationWithMedia.PATH = '/v1/api/ui/conversation/media';
